<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Quotation</strong></b-breadcrumb>
    <b-row>
      <b-card>
          
      <div class="box">
      <table>
        <tr class="txt_heading">
          <td >Quality</td>
          <td>Weight/Construction</td>
          <td>Price</td>
          <td>Consumption</td>
          <td>Cost / pc</td><td></td>
        </tr>
        <!-- <tbody v-for="(invoice_product, k) in invoice_products" :key="k">  -->
        <tr v-for="(invoice_product, k) in invoice_products" :key="k">
            <td>
                <input class="form-control" type="text" v-model="invoice_product.quality" />
            </td>
            <td>
                <input class="form-control" type="text" v-model="invoice_product.weight" />
            </td>
            <td>
                <input class="form-control text-right" type="number" min="0" step=".01" v-model="invoice_product.price" @change="calculateLineTotal(invoice_product)"
                />
            </td>
            <td>
                <input class="form-control text-right" type="number" min="0" step=".01" v-model="invoice_product.consumption" @change="calculateLineTotal(invoice_product)"
                />
            </td>
            <td>
                <input readonly class="form-control text-right" type="number" min="0" step=".01" v-model="invoice_product.cost" />
            </td>
            <td scope="row" class="trashIconContainer">
                <i class="fa fa-trash" @click="deleteRow(k, invoice_product)" style="font-size: 20px;color: red;"></i>
            </td>
          </tr></table>
            <tr>
              <button type='button' class="btn btn-info" @click="addNewRow">
                  <i class="fa fa-plus-circle"></i>
                  Add
              </button>
            </tr>
            <div  style="float: right;" >
            <tr>
              <td  ><b style="float: right;" >Total Cost : &nbsp;</b></td>
              <td class="td2">
                  <input readonly class="form-control text-right" type="number" min="0" step=".01" v-model="invoice_subtotal" @change="calculateFinalTotal()" />
              </td>
            </tr>  
            <tr>
              <td class="td2" ><b style="float: right;" >Print Cost : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="print_cost" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>   
            <tr>
              <td class="td2" ><b style="float: right;" >Embroidery : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="embroidery" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Misc. : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="misc" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >CM : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="cm" @change="calculateFinalTotal()" />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Trims : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="trims" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Packaging Trims : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="packaging_trims" @change="calculateFinalTotal()"
                  
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Packaging : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="packaging" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Transportation : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="transportation" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><span style="float: right;">(Optional) &nbsp;<b style="float: right;" >Licensee Margin : &nbsp;</b></span></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="licensee_margin" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Margin : &nbsp;</b></td>
              <td >
                  <input class="form-control text-right" type="number" min="0" step=".01" v-model="margin" @change="calculateFinalTotal()" 
                />
              </td>
            </tr>  
            <tr>
              <td class="td2" ><b style="float: right; " >Final Cost : &nbsp;</b></td>
              <td >
                  <input readonly class="form-control text-right" type="number" min="0" step=".01"  v-model="final_cost" id="final"/>
              </td>
            </tr>
            <tr>
              <td class="td2" ><b style="float: right;" >Remark : &nbsp;</b></td>
              <td >
                  <textarea rows="4" cols="50" class="form-control text-left" v-modal="remark"
                />
              </td>
            </tr>
          </div>
            
        <!-- </tbody> -->
        
      
      
      </div>
    </b-card>
    </b-row>
    </div>
</template>


<script>
import CONSTANTS from '@/utils/constants';
import auth from '@/utils/auth';
import Vue from 'vue';



const axios = require('axios')

  export default {
    data() {
      return {
        invoice_subtotal: 0,
        invoice_total: 0,
        invoice_tax: 5,
        invoice_products: [{
            quality: '',
            weight: '',
            price: '',
            consumption: '',
            cost: 0
        }],
        total_cost: 0,
        final_cost: 0,
        print_cost: 0,
        embroidery: 0,
        misc: 0,
        cm: 0,
        trims: 0,
        packaging_trims: 0,
        packaging: 0,
        transportation: 0,
        licensee_margin: 0,
        margin: 0,
        remark: '',
          
            
      }

    },
     created: function () {
        
    },
     methods: {
       saveInvoice() {
            console.log(JSON.stringify(this.invoice_products));
        },
        calculateTotal() {
            var subtotal, total;
            subtotal = this.invoice_products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.cost);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            this.invoice_subtotal = subtotal.toFixed(2);

            total = (subtotal * (this.invoice_tax / 100)) + subtotal;
            total = parseFloat(total);
            if (!isNaN(total)) {
                this.invoice_total = total.toFixed(2);
            } else {
                this.invoice_total = '0.00'
            }
        },
        calculateFinalTotal() {
          this.final_cost=parseFloat(parseFloat(this.invoice_subtotal) +parseFloat(this.print_cost) + parseFloat(this.embroidery) + parseFloat(this.misc) + parseFloat(this.cm) + parseFloat(this.trims) + parseFloat(this.packaging_trims) + parseFloat(this.packaging) + parseFloat(this.transportation) + parseFloat(this.licensee_margin) + parseFloat(this.margin)).toFixed(2);

        },
        calculateLineTotal(invoice_product) {
            var total = parseFloat(invoice_product.price) * parseFloat(invoice_product.consumption);
            if (!isNaN(total)) {
              invoice_product.line_total = total.toFixed(2);
              // this.invoice_subtotal=this.invoice_subtotal + total;

                this.final_cost = this.final_cost + this.invoice_subtotal 
                invoice_product.cost = total.toFixed(2);
                
            }
            this.calculateTotal();
        },
        deleteRow(index, invoice_product) {
            var idx = this.invoice_products.indexOf(invoice_product);
            console.log(idx, index);
            if (idx > -1) {
                this.invoice_products.splice(idx, 1);
            }
            this.calculateTotal();
        },
        addNewRow() {
            this.invoice_products.push({
                quality: '',
                weight: '',
                price: '',
                consumption: '',
                cost: 0,
            });
        }

}
  };
</script>
<style>
  .txt_heading{
    text-align: center;
    font-weight: bold;
  }
  .td2{
    width: 250px;
  }
  #final{
    background: #A9A9A9 !important;
  }
</style>
